import {useState} from 'react';
import {motion} from 'framer-motion';
import {useSelector} from 'react-redux';
import Selector from '../../../selectors/modules/lucky_wheel/rewards';

import SpinButton from './spin-button';

export default () => {
    const {rewards} = useSelector(Selector);

    return (
        <div className="lucky-wheel-details">
            <div className="background">
                <div className="confetti-1"></div>
                <div className="confetti-2"></div>
            </div>
            <div className="content">
                <SpinButton />

                <div className="rewards">
                    <div className="text">Possible Rewards</div>
                    <div className="rewards-list">
                        {rewards.map((reward, key) => {
                            return (
                                <div className={`reward ${reward.color}`} key={key}>
                                    <div className="reward-content">
                                        <div className="reward-image">
                                            <div className={reward.key}></div>
                                        </div>
                                        <div className="reward-details">
                                            <div className="amount">{reward.value}</div>
                                            <div className="name">{reward.name}</div>
                                            <div className="border"></div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}